import { PermissionEnum } from '@api/enum';
import { ICamera } from '@api/models';
import Img from '@components/Img/Img';
import useAuthPermission from '@hooks/use-auth-permission';
import { EllipsisHorizontalIcon } from '@icon/index';
import { Dropdown, DropdownItem, DropdownList, DropdownTrigger } from '@library/dropdown';
import { TRootState } from '@store/index';
import { GalleryCard } from 'modules/shared/features/content';
import moment from 'moment';
import { useSelector } from 'react-redux';

interface ICameraConcludeCard {
    camera: ICamera;
    onDeleteClick?: (camera: ICamera) => void;
    onRestoreClick?: (camera: ICamera) => void;
    onEditClick?: () => void;
    onBimClick?: () => void;
    hasDeletePermission?: boolean;
}

const CameraConcludeCard = (props: ICameraConcludeCard) => {
    const { camera, hasDeletePermission, onDeleteClick, onRestoreClick } = props;
    const { hasPermission } = useAuthPermission();
    const { profile } = useSelector((state: TRootState) => state);
    const isOlderThan3Days = (date: string) => {
        return moment().diff(moment(date, 'YYYYMMDD'), 'days') <= 3;
    };

    const userName = profile.info.username;
    const checkUserYN = 'yn';
    const checkUserYafer = 'yn.india';

    return (
        <GalleryCard
            className={`${
                camera.status === 'CONCLUDED'
                    ? 'bg-danger-100'
                    : camera.status === 'CONCLUDING'
                      ? 'bg-warning-100'
                      : camera.status === 'RESTORING'
                        ? 'bg-success-100'
                        : ''
            }`}
        >
            <GalleryCard.ActionBar className="">
                {hasPermission(PermissionEnum.TIMELAPSE_CAMERA_UPDATE) &&
                    (userName === checkUserYN || userName === checkUserYafer) && (
                        <Dropdown placement="bottom-end">
                            <DropdownTrigger className="w-6 h-6 grid place-items-center rounded-[4px] bg-floating-color image-overlay-button-shadow hover-transition hover:brightness-90">
                                <EllipsisHorizontalIcon className="text-grayscale-600" />
                            </DropdownTrigger>

                            <DropdownList className="min-w-[100px]">
                                {camera.status === 'CONCLUDED' && (
                                    <DropdownItem onClick={() => onRestoreClick(camera)} className="text-danger">
                                        Restore
                                    </DropdownItem>
                                )}

                                {hasDeletePermission && (
                                    <DropdownItem onClick={() => onDeleteClick(camera)} className="text-danger">
                                        Delete
                                    </DropdownItem>
                                )}
                            </DropdownList>
                        </Dropdown>
                    )}
            </GalleryCard.ActionBar>

            <GalleryCard.Media>
                {/* {camera.isConcluded} */}
                {camera.status === 'CONCLUDED' ? (
                    <div className="font-medium">Concluded</div>
                ) : camera.status === 'RESTORING' ? (
                    <div className="font-medium">Restoring...</div>
                ) : (
                    <div className="font-medium">Concluding...</div>
                )}
                <div className="mt-4">
                    <Img className="w-full aspect-image rounded-lg object-cover object-center" src={''} />
                </div>
            </GalleryCard.Media>

            <GalleryCard.Title>{camera.name}</GalleryCard.Title>
            <div className="text-xs">{camera._id}</div>

            {true ? (
                <GalleryCard.Footer>
                    <GalleryCard.FooterItem
                        label="Installed On"
                        content={moment(camera?.installationDate, 'YYYYMMDD').format('DD MMM, YYYY')}
                    ></GalleryCard.FooterItem>
                </GalleryCard.Footer>
            ) : (
                <GalleryCard.Footer>
                    <div className="flex flex-wrap gap-4 justify-between">
                        <GalleryCard.FooterItem
                            label="Last Image"
                            content={
                                camera?.latestImage?.datetime ? (
                                    <div
                                        className={
                                            isOlderThan3Days(camera?.latestImage?.datetime)
                                                ? 'text-green-500'
                                                : 'text-red-500'
                                        }
                                    >
                                        {moment(camera?.latestImage?.datetime, 'YYYYMMDDHHmmss').format(
                                            'h:mm A DD MMM, YY'
                                        )}
                                    </div>
                                ) : (
                                    '-'
                                )
                            }
                        ></GalleryCard.FooterItem>

                        <GalleryCard.FooterItem
                            label="Installed On"
                            content={moment(camera?.installationDate, 'YYYYMMDD').format('DD MMM, YYYY')}
                        ></GalleryCard.FooterItem>
                    </div>
                </GalleryCard.Footer>
            )}
        </GalleryCard>
    );
};

export default CameraConcludeCard;
